const RESIZE_OBSERVER_LOOP = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

export function isResizeObserverLoopError(message) {
  return typeof message === "string" && RESIZE_OBSERVER_LOOP.test(message);
}

function messageFromErrorEvent(event) {
  return (
    event?.message ||
    event?.error?.message ||
    (typeof event?.error === "string" ? event.error : "")
  );
}

/**
 * CRA's overlay treats this browser notification as a crash. It is a layout
 * batching warning, not an application failure — swallow it so SPA navigation
 * (e.g. Midpoint Media header links) can complete.
 */
export function installResizeObserverLoopErrorIgnore(target = window) {
  if (!target?.addEventListener) {
    return () => {};
  }

  const onErrorEvent = (event) => {
    if (!isResizeObserverLoopError(messageFromErrorEvent(event))) {
      return;
    }
    event.preventDefault?.();
    event.stopImmediatePropagation?.();
  };

  const previousOnError = target.onerror;
  target.onerror = function onError(message, source, lineno, colno, error) {
    if (isResizeObserverLoopError(String(message || error?.message || ""))) {
      return true;
    }
    if (typeof previousOnError === "function") {
      return previousOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  target.addEventListener("error", onErrorEvent, true);
  return () => {
    target.removeEventListener("error", onErrorEvent, true);
    if (target.onerror === onErrorEvent || target.onerror?.name === "onError") {
      target.onerror = previousOnError || null;
    }
  };
}
